import { Flame } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { NewsArticle } from '@/types/news';

type BreakingTickerProps = {
  articles: NewsArticle[];
};

export function BreakingTicker({ articles }: BreakingTickerProps) {
  if (articles.length === 0) return null;

  return (
    <div className="safe-px sticky top-14 z-30 border-b border-divergent-yellow/30 bg-divergent-yellow text-black">
      <div className="mx-auto flex max-w-app items-center gap-3 overflow-hidden py-2">
        <div className="inline-flex shrink-0 items-center gap-1 text-xs font-black uppercase tracking-[0.12em]">
          <Flame size={15} aria-hidden="true" />
          Ahora
        </div>
        <div className="flex min-w-0 gap-8 overflow-hidden whitespace-nowrap text-sm font-semibold">
          {articles.map((article) => (
            <Link key={article.id} to={`/noticia/${article.slug}`} className="truncate hover:underline">
              {article.title}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
